import type { AxiosResponse } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useValidateOTP = () =>
  useMutation({
    mutationFn: validateOTP,
  });

const validateOTP = async (params: ValidateOTPBody) => {
  const { data } = await api.post<
    ValidateOTPResponse,
    AxiosResponse<ValidateOTPResponse>,
    ValidateOTPBody
  >(apiConfig.routes.auth.validateOTP, params);
  return data;
};

export type ValidateOTPBody = {
  identifier: string;
  token: string;
};

type ValidateOTPResponse = {
  is_valid: boolean;
};
